module.exports = __webpack_public_path__ + "img/shotgun.9c5f27a2.svg";